import { Typography } from '@euler/app/components/typography';
import { aiColors, tint } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { Check, WandSparkles, X } from 'lucide-react-native';
import { memo } from 'react';
import { View } from 'react-native';
import { BiButton } from '../../components/ui/BiButton';

/**
 * Over a dashboard showing a pending change set: what it does, what it
 * removes, and 应用 / 放弃 — the same taps as the card in the chat.
 */
export const GhostBanner = memo(
  ({
    summary,
    removed,
    busy,
    onApply,
    onDiscard,
  }: {
    summary: string;
    removed: string[];
    /** A reply is running: taps wait. */
    busy: boolean;
    onApply: () => void;
    onDiscard: () => void;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <View
        accessibilityRole="summary"
        style={{
          flexDirection: 'row',
          flexWrap: 'wrap',
          alignItems: 'center',
          gap: rpx(12),
          padding: rpx(12),
          marginBottom: rpx(16),
          borderRadius: rpx(14),
          borderWidth: 1,
          borderColor: tint(aiColors.amber, 0.4),
          backgroundColor: tint(aiColors.amber, 0.08),
        }}
      >
        <WandSparkles size={18} color={aiColors.amber} />
        <View style={{ flex: 1, minWidth: rpx(200), gap: rpx(2) }}>
          <Typography.Text medium size={rpx(14)} color={aiColors.foreground}>
            AI 修改预览
          </Typography.Text>
          <Typography.Text
            size={rpx(12)}
            lineHeight={rpx(18)}
            color={aiColors.mutedForeground}
          >
            {summary}
          </Typography.Text>
          {removed.length ? (
            <Typography.Text size={rpx(12)} color={aiColors.red}>
              将删除：{removed.map(title => `「${title}」`).join('、')}
            </Typography.Text>
          ) : null}
        </View>
        <View style={{ flexDirection: 'row', gap: rpx(8) }}>
          <BiButton title="放弃" icon={X} disabled={busy} onPress={onDiscard} />
          <BiButton
            title="应用"
            icon={Check}
            tone="primary"
            disabled={busy}
            onPress={onApply}
          />
        </View>
      </View>
    );
  },
);
